module.exports = __webpack_public_path__ + "img/202402_07.c0783927.jpg";